module.exports = __webpack_public_path__ + "img/naaste.a1c27853.png";